module.exports = __webpack_public_path__ + "img/facebook.0e6dca07.svg";